import { useEffect, useState } from "react";

const useGetDownloadLink = () => {
	const [ downloadLink, setDownloadLink ] = useState ( null );

	useEffect ( () => {
		const userAgent = navigator.userAgent || navigator.vendor || window.opera;

		let deviceType = "other";

		if ( /android/i.test ( userAgent ) ) {
			deviceType = "android";
		} else if ( /iPad|iPhone|iPod/.test ( userAgent ) && !window.MSStream ) {
			deviceType = "ios";
		}

		let link = "";

		if ( deviceType === "android" ) {
			link =
				"intent://splash#Intent;scheme=rooter;package=com.threesixteen.app;S.browser_fallback_url=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.threesixteen.app%26hl%3Den_IN%26gl%3DUS;end";
		} else if ( deviceType === "ios" ) {
			link =
				"https://apps.apple.com/in/app/rooter-watch-gaming-esports/id1115677906";
		} else {
			link =
				"https://play.google.com/store/apps/details?id=com.threesixteen.app&hl=en_IN&gl=US";
		}

		setDownloadLink ( link );
	}, [] );

	return downloadLink;
};

export default useGetDownloadLink;

